export default "__VITE_ASSET__BACfBK6V__"